import { apiCall } from "./index";

export const getBranches = (page = 1, limit = 10) =>
  apiCall(`/branches?page=${page}&limit=${limit}`);

export const getBranchById = (branchId) =>
  apiCall(`/branches/${branchId}`);

export const getShiftsByBranch = (branchId) =>  
  apiCall(`/branches/${branchId}/shifts`);

export const getManagersByBranch = (branchId) =>  
  apiCall(`/branches/${branchId}/managers`);

export const getTeamLeadersByBranchAndShift = (branchId, shiftId) =>
  apiCall(`/branches/${branchId}/shifts/${shiftId}/team-leaders`);

export const createBranch = (branchData) =>
  apiCall(`/branches`, "POST", branchData);

export const updateBranch = (branchId, branchData) =>
  apiCall(`/branches/${branchId}`, "PUT", branchData);

export const deleteBranch = (branchId) =>
  apiCall(`/branches/${branchId}`, "DELETE");
